<script>import { ICON_STROKE_MAP } from "./";
export let size = 24;
</script>
<svg width={size} height={size} stroke-width={ICON_STROKE_MAP[size]} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...$$props}><path d="M15 6L9 12L15 18" stroke="currentColor"/></svg>